/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, Tooltip } from 'react-bootstrap';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  dispatchProvideDetails,
  dispatchProviderListDetails,
  getProviderDetails,
  getProviderIdTypeDetails,
  getProviderList,
  searchProviderReqAction,
} from '../store/action';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { cellHead, ProviderHead } from './tableHead';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { NO_RESULT_FOUND_ERROR } from '../../../../SharedModules/Errors/constantMessageData';
import {
  navigateToNextCell,
  onCellFocused,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { saveContactData } from '../../../Maintain/Plan/store/actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
// import { createSelector } from 'reselect';
import { debounce } from 'lodash';

function Provider(props) {
  const dispatch = useDispatch();
  const debouncedSearch = React.useCallback(
    debounce((data) => {
      setspinnerLoader(true);
      searchProviderList(data);
      dispatch(searchProviderReqAction(data));
    }, 300),
    []
  );
  // const selectProviderList = createSelector(
  //   (state) => state.sharedState.ProviderReducer.providerList,
  //   (providerList) => providerList?.data || []
  // );
  const searchProvideridTypeDetail = (value) =>
    dispatch(getProviderIdTypeDetails(value));
  const searchProviderList = (value) =>
    dispatch(
      getProviderList(value, (error) => {
        setErrorMessages([error]);
        setspinnerLoader(false);
        setSearchClicked(false);
      })
    );
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const payload = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );
  const providerSeachList = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerList
  );
  const [workerRowData, setWorkerRowData] = useState([]);
  const [initialRowData, setInitialRowData] = useState([]);
  const [workerProcessing, setWorkerProcessing] = useState(false);
  const BACKGROUND_CHUNK_SIZE = 20;

  function mapProviderTypeDesc(rows = []) {
    if (!Array.isArray(rows) || rows.length === 0) return [];

    const lookup = (code) => {
      if (!code || !providerIdList || providerIdList.length === 0)
        return code || '';
      const found = providerIdList.find(
        (it) =>
          it?.codeValueID?.codeValue === code ||
          String(it?.codeValueID?.codeValue) === String(code)
      );
      return (
        found?.shortDescription || found?.codeValueID?.codeValue || code || ''
      );
    };

    return rows.map((r) => {
      try {
        const code = r?.providerPK?.providerIdTypeCd;
        return { ...r, providerIdTypeDesc: lookup(code) };
      } catch (e) {
        return r;
      }
    });
  }

  useEffect(() => {
    if (
      providerSeachList &&
      providerSeachList.data &&
      providerSeachList.data.length > 0
    ) {
      const firstChunk = providerSeachList.data.slice(0, 20);
      setInitialRowData(mapProviderTypeDesc(firstChunk));
    } else {
      setInitialRowData([]);
    }
  }, [providerSeachList]);

  useEffect(() => {
    if (
      providerSeachList &&
      providerSeachList.data &&
      providerSeachList.data.length > 20
    ) {
      setWorkerProcessing(true);
      const restData = providerSeachList.data.slice(20);
      let processedRows = [];
      let chunkIndex = 0;
      let cancelled = false;

      const processNextChunk = () => {
        if (cancelled) {
          return;
        }

        const chunk = restData.slice(
          chunkIndex,
          chunkIndex + BACKGROUND_CHUNK_SIZE
        );
        if (chunk.length === 0) {
          setWorkerRowData(processedRows);
          setWorkerProcessing(false);
          return;
        }

        processedRows = processedRows.concat(mapProviderTypeDesc(chunk));
        chunkIndex += BACKGROUND_CHUNK_SIZE;
        window.setTimeout(processNextChunk, 0);
      };

      processNextChunk();

      return () => {
        cancelled = true;
      };
    }

    setWorkerRowData([]);
    setWorkerProcessing(false);
    return undefined;
  }, [providerSeachList]);
  const providerData = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.searchProviderRequest
  );
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [selectedOption, setSelectedOption] = useState('NAME');
  const [providedID, setProviderID] = useState('ALL');
  const [providerName, setProviderName] = useState();
  const [providerIdList, setProviderIdList] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [spinnerLoader, setspinnerLoader] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);

  const handleChangeID = (e) => {
    setErrorMessages([]);
    setProviderID(e.target.value);
  };
  const handleChangeName = (e) => {
    setErrorMessages([]);
    setProviderName(e.target.value);
  };
  const onClickSearch = () => {
    setErrorMessages([]);
    setSearchClicked(true);
    const data = {
      searchVal: providerName ? providerName?.trim() : '',
      searchBy: selectedOption || 'NAME',
      page: '0',
      pageSize: '100',
      providerIdTypeCd: providedID || 'ALL',
    };
    // setspinnerLoader(true);
    debouncedSearch(data);
  };

  const reset = () => {
    setSelectedOption('NAME');
    setProviderID('ALL');
    setProviderName('');
    dispatch(dispatchProviderListDetails());
    setSearchClicked(false);
  };

  useEffect(() => {
    dispatch(saveContactData({}));
    searchProvideridTypeDetail({});
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    setspinnerLoader(false);
    if (
      !(
        providerSeachList &&
        providerSeachList.data &&
        providerSeachList?.data[0]
      ) &&
      searchClicked
    ) {
      setErrorMessages([NO_RESULT_FOUND_ERROR]);
      setSearchClicked(false);
    }
  }, [providerSeachList]);

  useEffect(() => {
    if (providerData && Object.keys(providerData).length > 0) {
      setProviderID(providerData.providerIdTypeCd ?? 'ALL');
      setProviderName(providerData.searchVal ?? '');
      setSelectedOption(providerData.searchBy ?? 'NAME');
    }
  }, [providerData]);

  const onClickProvider = (selectedProv) => {
    dispatch(dispatchProvideDetails(selectedProv?.data));
    const data = {
      providerId: selectedProv?.data?.providerPK?.providerId,
      providerIdTypeCd: selectedProv?.data?.providerPK?.providerIdTypeCd,
      userID: userId || logInUser?.toUpperCase(),
      // userLastName: 'TEST',
      functionCode: 'Provider',
      eventInquryKeyVO: [
        {
          keyType: 'Provider ID',
          key: selectedProv?.data?.providerPK?.providerId,
        },
      ],
    };
    dispatch(getProviderDetails(data));
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const existingItem = updateTabs.find(
      (item) => item.navTo === '/providerDetails'
    );
    if (existingItem) {
      updateTabs = updateTabs.map((item) => {
        if (item.navTo === '/providerDetails') {
          return {
            navTo: '/providerDetails',
            value: 'Provider Details',
          };
        }
        return item;
      });
    } else {
      updateTabs.push({
        navTo: '/providerDetails',
        value: 'Provider Details',
      });
    }
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/providerDetails',
    });
  };
  const handleChange = (e) => {
    setErrorMessages([]);
    setSelectedOption(e.target.value);
  };

  useEffect(() => {
    if (Array.isArray(payload) && payload.length > 0) {
      const allOption = {
        codeDomainKey: null,
        codeValue: null,
        codeValueID: {
          codeDomainKey: 'All',
          codeValue: 'all',
        },
      };

      const updatedList = [allOption, ...payload];
      setProviderIdList(updatedList);
    } else {
      setProviderIdList([]);
    }
  }, [payload]);

  useEffect(() => {
    if (providerIdList && providerIdList.length > 0) {
      setInitialRowData((rows) => mapProviderTypeDesc(rows));
      setWorkerRowData((rows) => mapProviderTypeDesc(rows));
    }
  }, [providerIdList]);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.providerPK;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        PROVIDER_ID: `${selectedRow?.providerId}`,
        PROVIDER_ID_TYPE_CD: `${selectedRow?.providerIdTypeCd}`,
      });
    }
  };

  const frameworkComponents = useMemo(
    () => ({
      nameRenderName: (cellInfo) => {
        const name = cellInfo.data?.name;
        const normalizedName = name?.replace(/\s+/g, ' ').trim();

        return normalizedName?.length > 31 ? (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{normalizedName}</Tooltip>}
          >
            <div>{normalizedName}</div>
          </OverlayTrigger>
        ) : (
          <div>{normalizedName}</div>
        );
      },
    }),
    []
  );

  return (
    <>
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space devider-line pb-0">
          {spinnerLoader && <Spinner load={spinnerLoader} />}
          <CustomSeparator parent1="Display" parent2="Provider" />
          {!fullScreenView && (
            <>
              <DisplayErrorMessages
                errorMessages={[...new Set(errorMessages)]}
              />
              <div className="panel mb-3">
                <div className="row">
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family" id="search_by_label">
                        Search By <span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="search_by_label"
                                name="row-radio-buttons-group"
                                value={selectedOption}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <FormControlLabel
                                  style={{ marginRight: '15px' }}
                                  value="ID"
                                  control={<Radio />}
                                  label="Provider ID"
                                  data-test="radio-all"
                                />
                                <FormControlLabel
                                  style={{ marginRight: '15px' }}
                                  value="NAME"
                                  control={<Radio />}
                                  label="Provider Name"
                                  data-test="radio-Selected"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="provider_id_type_label"
                      >
                        Provider ID Type <span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            fullWidth
                            select
                            placeholder=""
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              'aria-labelledby': 'provider_id_type_label',
                            }}
                            name="providerIDType:"
                            value={providedID || 'ALL'}
                            onChange={handleChangeID}
                          >
                            <MenuItem selected key="all" value="ALL">
                              ALL
                            </MenuItem>
                            {providerIdList && providerIdList?.length > 0
                              ? providerIdList.map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.codeValueID.codeValue}
                                      value={item.codeValueID.codeValue}
                                      className="frr-logcheck-dropdown-item"
                                    >
                                      {`${item.codeValueID.codeValue}  ${item.shortDescription}`}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="search_for_label"
                      >
                        Search for
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            fullWidth
                            placeholder=""
                            value={providerName}
                            onChange={handleChangeName}
                            type="text"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 40,
                              'aria-labelledby': 'search_for_label',
                            }}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="btn-wrapper mb-2">
                  <div className="float-right mt-2 hide-on-print">
                    <Button
                      className="btn btn-success btn-save"
                      onClick={onClickSearch}
                    >
                      {' '}
                      <SVGComponent iconName="Icon-search" />
                      Search
                    </Button>
                    <Button className="btn btn-cancel" onClick={reset}>
                      <SVGComponent iconName="Icon-cancel" />
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="panel tBillPanel-space pb-0">
          <div className="FRR-custom-table tbl-manufacturer-home">
            <div className="frr-tbl-with-feature">
              <TableGrid
                gridHeight={fullScreenView ? '70vh' : 350}
                cellClickedListener={onClickProvider}
                rowData={initialRowData.concat(workerRowData)}
                defaultCol={{ editable: false }}
                columnDefs={selectedOption === 'NAME' ? ProviderHead : cellHead}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                navigateToNextCell={navigateToNextCell}
                // tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                exportFile
                data-testid="onEditingStopped"
                fileName="Provider"
                //handleViewHistory={handleViewHistory}
                frameworkComponents={frameworkComponents}
                totalResult={
                  providerSeachList && providerSeachList.data
                    ? providerSeachList.data.length
                    : 0
                }
              />
            </div>
          </div>
          {showViewHistory ? (
            <ViewHistoryComponent
              setShowViewHistory={setShowViewHistory}
              tableName="PROVIDER"
              keyValue={keyValue}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
export default withRouter(Provider);
